<template>
<v-card tile flat class="grey lighten-4" >
  <v-overlay absolute v-if="req.biz.loading" >
    <v-progress-circular size="72" color="amber" indeterminate />
  </v-overlay>
  <request-status :request="req.biz" />

  <template >

    <v-card-text >
      <!-- R: {{roles}} -->
      <!-- <pre v-text="roles" class="caption grey lighten-4 pa-3" /> -->
      <v-row v-if="withPackage"
        class="justify-center" >
        <template v-for="p in packages" >
          <v-btn large
            @click="selectedPackage=p"
            class="ma-4" color="info"
            style="min-width:150px;"
            :outlined="selectedPackageId !== p.id"
            :key="p.id" >
            {{p.title}}
          </v-btn>
        </template>
      </v-row>
      <!-- <v-row>
        {{selectedPackageId}}
        <pre v-text="selectedPackage" class="caption grey lighten-4 pa-3" />
        <pre v-text="roles" class="caption grey lighten-4 pa-3" />
      </v-row> -->
      <v-row >
        <v-col
          v-for="role in roles"
          :key="role.id"
          class="d-flex flex-row col-12 col-sm-6" >
          <role-card
            :role="role"
            :selected="isSelected(role)"
            @selected="setRole" />
        </v-col>
      </v-row>
    </v-card-text>
  </template>
</v-card>
</template>
<script>
import RoleCard from '@/components/cards/RoleCard.vue'

export default {
  name: 'RolePicker',
  components: {RoleCard},
  props: {
    businessId: { type: [String, Number], required: true },
    packageTitle: { type: String },
    package: { type: Object },
    role: { type: Object },
    withPackage: { type: Boolean, default: false }
  },
  data () {
    return {
      selectedPackage: null,
      selectedRole: null,
      req: {
        biz: {
          resource: 'ag.business'
        }
      }
    }
  },
  mounted () {
    if (this.packageTitle) {
      this.selectedPackage = this.getPackageByTitle(this.packageTitle)
    }
    this.get()
  },
  methods: {
    isSelected (role) {
      if (!this.selectedRole) { return false }
      return role.id === this.selectedRole.id
    },
    setRole(role) {
      this.selectedRole = role
      this.$emit('selected', role)
    },
    get () {
      this.req.biz.resourceId = this.businessId
      this.$request('get', this.req.biz)
    },
    getPackageByTitle (title) {
      return this.packages.find((pkg) => {
        return pkg.title === title
      })
    }
  },
  watch: {
    seatId () {
      if (this.seatId) {
        this.get()
      }
    },
    selectedPackageId () {
      this.$emit('update:package', this.selectedPackage)
    },
    selectedRoleId () {
      this.$emit('update:role', this.selectedRole)
    },
    defaultPackageId () {
      if (!this.selectedPackage && this.defaultPackageId) {
        let pkg = this.getPackageByTitle(this.defaultPackage.title)
        this.selectedPackage = pkg
      }
    }
  },
  computed: {
    seat () {
      return this.value
    },
    defaultPackage () {
      return this.getObjectPath(this.business, 'package')
    },
    defaultPackageId () {
      return this.getObjectPath(this.defaultPackage, 'id')
    },
    roles () {
      if (this.selectedPackageId) {
        let roles = this.getObjectPath(this.selectedPackage, 'roles', [])
        return roles.filter((role) => { return role.active === true })
      }
      return []
      // let vm = this
      // if (this.business) {
      //   let lookup = this.business.package_role_prices || []
      //   let packageIndex = lookup.findIndex((pkg) => {
      //     let title = this.getObjectPath(vm, 'pkg.title')
      //     console.log(pkg.title === title)
      //     return pkg.title === title
      //   })
      //   if (packageIndex >= 0) {
      //     return lookup[packageIndex].roles
      //   }
      // }
    },
    selectedPackageId () {
      return this.getObjectPath(this.selectedPackage, 'id')
    },
    selectedRoleId () {
      return this.getObjectPath(this.selectedRole, 'id')
    },
    business () {
      return this.getObjectPath(this.req, 'biz.result')
    },
    // businessId () {
    //   return this.getObjectPath(this.seat, 'business')
    // },
    requestStatus () {
      return this.getObjectPath(this.req, 'biz.status')
    },
    packages () {
      return this.getObjectPath(this.req, 'biz.result.package_role_prices', [])
    }
  }
}
</script>
